export default [
    {
        path: '/',
        redirect: 'finances'
    },
    // {
    //     path: '/personal',
    //     component: () => import('./index.vue'),
    // },
]